// Shared helpers for client reliability score badges and copy.
// Tiers come from the backend (`/api/clients` → `client.reliability.tier`).
// Tier rules (last 90 days, sample = completed + no-shows):
//   < 3 sessions  → "new"     (grey)
//   ≥ 90%         → "green"
//   ≥ 70%         → "yellow"
//   ≥ 50%         → "orange"
//   < 50%         → "red"

export const RELIABILITY_TIERS = {
  green: {
    label: "Reliable",
    chip: "bg-[#E3F1E9] text-[#1D6B4A] border-[#BFE3CE]",
    dot: "bg-[#1D6B4A]",
    text: "text-[#1D6B4A]",
  },
  yellow: {
    label: "Steady",
    chip: "bg-[#FBF4DD] text-[#7A5E18] border-[#ECDCA6]",
    dot: "bg-[#C79A2E]",
    text: "text-[#7A5E18]",
  },
  orange: {
    label: "Watch",
    chip: "bg-[#F9E9E0] text-[#9C4420] border-[#F0D2C2]",
    dot: "bg-[#D9774A]",
    text: "text-[#9C4420]",
  },
  red: {
    label: "At risk",
    chip: "bg-[#F9E4DF] text-[#A8372A] border-[#F0C9C1]",
    dot: "bg-[#A8372A]",
    text: "text-[#A8372A]",
  },
  new: {
    label: "New",
    chip: "bg-[#EEE9E0] text-[#6B635C] border-[#E0D8CA]",
    dot: "bg-[#B8AE9E]",
    text: "text-[#6B635C]",
  },
};

export function reliabilityStyle(tier) {
  return RELIABILITY_TIERS[tier] || RELIABILITY_TIERS.new;
}

export function formatReliabilityScore(rel) {
  if (!rel || rel.score === null || rel.score === undefined) return "—";
  return `${Math.round(rel.score)}%`;
}

export function reliabilityInsight(rel) {
  if (!rel) return "";
  const { tier, sample, completed, no_shows } = rel;
  if (tier === "new") {
    return `Only ${sample} completed/no-show session${sample === 1 ? "" : "s"} in the last 90 days. Need at least 3 to score.`;
  }
  if (tier === "green") {
    return `Excellent attendance. ${completed} completed, ${no_shows} no-show${no_shows === 1 ? "" : "s"} in 90 days.`;
  }
  if (tier === "yellow") {
    return `Mostly reliable. ${no_shows} no-show${no_shows === 1 ? "" : "s"} in the last 90 days.`;
  }
  if (tier === "orange") {
    return `Inconsistent attendance. ${no_shows} no-show${no_shows === 1 ? "" : "s"} of ${sample} sessions. Worth a check-in.`;
  }
  return `High no-show rate. ${no_shows} of ${sample} sessions missed. Consider a re-engagement chat.`;
}
